<template>
<div class="handleWrap">
  <div class="handleLeft">
    <slot name="left"></slot>
  </div>
  <div class="handleRight">
    <slot name="right"></slot>
  </div>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.handleWrap {
  // height: 65px;
  // line-height: 65px;
  // padding: 19px 22px 19px 10px !important;
  background-color: #fff;

  .handleLeft {
    float: left;
  }

  .handleRight {
    float: right;
  }

  .line {
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 24px;
    background: #0B2D4D;
    margin: 0 10px;
  }
}
</style><style lang="scss">
.handleWrap {
  .el-input {
    width: 170px;
    height: 36px !important;
  }

  .el-select {
    height: 36px;
    margin-left: 12px;
  }

  .el-input {
    margin-left: 12px;
  }

  .el-input .el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .primaryBtn {
    height: 36px;
    vertical-align: middle;
    margin-left: 12px;
  }
  .el-date-editor {
    height: 36px;
    line-height: 36px;
    // margin-top: 5px;
  }

  .delSome {
    float: right;
    height: 36px;
    vertical-align: middle;
    padding: 0 10px;
  }

  .el-date-editor .el-range__icon,
  .el-select .el-input .el-select__caret {
    line-height: 36px !important;
  }
}
</style>
